import {
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable,
} from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { Link } from 'react-router';

import api from '../../lib/api';
import { formatDateToYYYYMMDD } from '../../lib/dateHelper';
import { DataTable } from './datatable';
import DatatableSortButton from './datatableSortButton';

export const columns = [
    {
        accessorKey: 'name',
        header: ({ column }) => <DatatableSortButton column={column}>Namn</DatatableSortButton>,
        cell: info => {
            const competition = info.row.original;
            return <Link to={`/competition/${competition?.id}`} className='text-blue-600 font-medium hover:underline'>{competition?.name}</Link>;
        }
    },
    {
        accessorKey: 'start_date',
        header: ({ column }) => <DatatableSortButton column={column}>Startdatum</DatatableSortButton>,
        cell: info => {
            return formatDateToYYYYMMDD(info.getValue());
        },
    },
    {
        accessorKey: 'end_date',
        header: ({ column }) => <DatatableSortButton column={column}>Slutdatum</DatatableSortButton>,
        cell: info => {
            return formatDateToYYYYMMDD(info.getValue());
        },
    },
];

export function ClubCompetitionsDatatable({ clubId }) {
    const [sorting, setSorting] = useState([{ id: "start_date", desc: false }]);
    const [columnFilters, setColumnFilters] = useState([]);
    const [competitions, setCompetitions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchClubCompetitions = async () => {
        try {
            const response = await api.get(`https://skhrf-api.cmdigital.se/v1/competitions/club/${clubId}`);
            setCompetitions(response.data);
        } catch (error) {
            console.error('Error fetching competitions:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchClubCompetitions();
    }, [clubId]);


    const table = useReactTable({
        data: competitions,
        columns,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        onColumnFiltersChange: setColumnFilters,
        getFilteredRowModel: getFilteredRowModel(),
        state: {
            sorting,
            columnFilters,
        },
    });

    return <DataTable table={table} isLoading={isLoading} columns={columns} />;
}